<template>
  <v-card id="listener_registra_pezzi" style="height: 90%; overflow-y: auto">
    <v-toolbar
      class="white--text"
      color="indigo"
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title dense> Dichiarazione Alternativa </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone salva e continua -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="mr-5"
            @click="clickSalvaEContinua"
            large
          >
            <v-icon color="success" style="font-size: 40px">
              mdi-floppy
            </v-icon>
          </v-btn>
        </template>
        <span>Salva e Continua</span>
      </v-tooltip>

      <!-- Bottone di aggiornamento dei dati -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="aggiornaDatiMacchina"
            large
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary" large> mdi-autorenew </v-icon>
          </v-btn>
        </template>
        <span>Aggiorna</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di indietro senza salvare -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn large v-bind="attrs" v-on="on" @click="clickIndietro">
            <v-icon color="error" style="font-size: 40px"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-row class="mb-5" align="center" justify="center">
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff"
              ><b>Utente:</b></span
            >
            <span class="label"> {{ nome_utente }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff">
              <b>Commessa:</b>
            </span>
            <span class="label"> {{ work_order_sel.cod_commessa }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff">
              <b>Start:</b>
            </span>
            <span class="label">
              {{
                work_order_sel.ora_start != "" &&
                work_order_sel.ora_start != null &&
                work_order_sel.ora_start != undefined
                  ? `${work_order_sel.ora_start.substr(
                      8,
                      2
                    )}/${work_order_sel.ora_start.substr(
                      5,
                      2
                    )}/${work_order_sel.ora_start.substr(
                      0,
                      4
                    )} ${work_order_sel.ora_start.substr(11, 5)}`
                  : "N/A"
              }}
            </span>
          </span>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col cols="4" align="start">
          <span>
            <span class="label mr-2" style="color: #3399ff">
              <b>Macchina:</b>
            </span>
            <span class="label"> {{ work_order_sel.cod_macchina }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span class="mr-5">
            <span class="label mr-2" style="color: #3399ff">
              <b>Work Order:</b>
            </span>
            <span class="label"> {{ work_order_sel.cod_fase }}</span>
          </span>
        </v-col>
        <v-col cols="4" align="start">
          <span>
            <span class="label mr-2" style="color: #3399ff">
              <b>Stop:</b>
            </span>
            <span class="label">
              {{
                work_order_sel.ora_stop != "" &&
                work_order_sel.ora_stop != null &&
                work_order_sel.ora_stop != undefined
                  ? `${work_order_sel.ora_stop.substr(
                      8,
                      2
                    )}/${work_order_sel.ora_stop.substr(
                      5,
                      2
                    )}/${work_order_sel.ora_stop.substr(
                      0,
                      4
                    )} ${work_order_sel.ora_stop.substr(11, 5)}`
                  : "N/A"
              }}
            </span>
          </span>
        </v-col>
      </v-row>

      <!-- Riga della tabella dinamica dei dati di produzione -->
      <v-row align="center" justify="center">
        <v-col cols="12" align="center">
          <!-- Tabella dei dati automatici (se ci sono dati) -->
          <v-data-table
            class="elevation-2"
            :headers="tabella_custom.colonne"
            hide-default-footer
            :items="result_query"
            v-if="tabella_custom.id_query > 0"
          >
            <!-- Spazio del titolo della tabella -->
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  {{ tabella_custom.titolo }}
                </v-toolbar-title>
              </v-toolbar>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td
                  v-for="(colonna, index) in tabella_custom.colonne"
                  :style="calcoloFormato(item, colonna)"
                  :key="index"
                >
                  {{ item[colonna.value] }}
                </td>
              </tr>
            </template>
          </v-data-table>

          <!-- Card alternativa alla tabella per dire che non ci sono dati -->
          <v-card outlined width="500px" v-else>
            <v-card-text>
              <span style="font-size: 15px">
                <b>Nessun dato automatico di produzione disponibile.</b>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-5" justify="start" align="start">
        <!-- Spazio in cui ho incolonnato il campo di
            input e le textarea del WO e della registrazione
            specifica che sto effettuando -->
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="12" align="start">
              <v-text-field
                background-color="#ffffff"
                dense
                height="50px"
                hide-details
                outlined
                style="
                  display: inline-block;
                  font-size: 35px;
                  font-weight: bold;
                  line-height: 35px;
                  max-width: 200px;
                  padding: 0px;
                "
                type="number"
                v-model="pezzi_prodotti"
              >
                <template v-slot:prepend>
                  <span style="color: #3399ff; font-size: 18px">
                    Quantità:
                  </span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                background-color="#ffffff"
                dense
                hide-details
                label="Note Work Order"
                outlined
                readonly
                style="
                  display: inline-block;
                  font-size: 15px;
                  font-weight: bold;
                  line-height: 25px;
                  padding: 0px;
                  width: 100%;
                "
                v-model="note_workorder"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                background-color="#ffffff"
                dense
                hide-details
                label="Note Registrazione"
                outlined
                style="
                  display: inline-block;
                  font-size: 15px;
                  font-weight: bold;
                  line-height: 35px;
                  padding: 0px;
                  width: 100%;
                "
                v-model="note"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>

        <!-- Select codici articolo ed etichetta -->
        <v-col cols="6">
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-autocomplete
                @change="setCodEtichette"
                class="mt-10"
                :items="cod_articoli_alt"
                item-text="cod_articolo"
                item-value="id_articolo"
                label="Cod. Articolo"
                v-model="id_articolo_sel"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                class="mt-10"
                :items="cod_etichette_alt"
                item-text="cod_articolo_packaging"
                item-value="id_articolo_packaging"
                label="Cod. Packaging"
                v-model="id_articolo_packaging_sel"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :size="64">{{ snackbar_icon }}</v-icon>
      <h2 class="ml-16">{{ snackbar_text }}</h2>

      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="controllo_dialog_visible">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Controllo Qualità
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="controllo_dialog_visible = false" small>
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="max-height: 500px; overflow-y: auto">
          <Controllo />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG SALVA ed ESCI -->
    <v-dialog v-model="dialog_conferma" width="350">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Dichiarazione
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-card-text>
            Confermi di voler procedere con la registrazione?
          </v-card-text>
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0">
            <v-col cols="6" style="text-align: right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="dialog_conferma = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Annulla</span>
              </v-tooltip>
            </v-col>
            <v-col cols="6" style="text-align: left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="salvaEContinua" small v-bind="attrs" v-on="on">
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>Conferma</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import moment from "moment/moment";
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TabellaCustomClass from "@/classes/TabellaCustomClass.js";

/* class Scarto {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_movimenti", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "pezzi", default_val: 0 },
      { nome: "tipo_causale", default_val: "SCARTO" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
} */

export default {
  name: "RegistraPezzi",
  components: { Controllo, SnackbarQV },
  props: {
    flag_em_registrazione: { type: String, default: "" },
    id_header_query: { type: Number, default: null },
    visible: { type: Boolean, default: false },
    work_order_sel: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      id_articolo_packaging_sel: null,
      id_articolo_sel: null,
      nome_utente: localStorage.getItem("nominativo"),
      note: "",
      note_workorder: "",
      oggi: moment().format("DD/MM/YYYY"),
      pezzi_prodotti: null,
      tabella_custom: new TabellaCustomClass(),

      // Modal
      caricamento_dati: false,
      controllo_dialog_visible: false,
      dialog_conferma: false,
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_text: "",

      // Array
      cod_articoli_alt: [],
      cod_etichette_alt: [],
      headers_log_macchina: [],
      result_query: [],
      tabella_parametri_query: [],
    };
  },
  watch: {
    pezzi_prodotti: {
      immediate: true,
      handler() {
        if (
          parseInt(this.pezzi_prodotti) +
            parseInt(
              this.work_order_sel.pezzi_avanzati_fase != null
                ? this.work_order_sel.pezzi_avanzati_fase
                : 0
            ) >
          parseInt(this.work_order_sel.quantita)
        ) {
          this.snackbar = true;
          this.snackbar_background = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_text =
            "Quantità prodotta maggiore della quantità pianificata.";
        }

        if (
          parseInt(this.pezzi_prodotti) +
            parseInt(
              this.work_order_sel.pezzi_avanzati_fase != null
                ? this.work_order_sel.pezzi_avanzati_fase
                : 0
            ) ==
          parseInt(this.work_order_sel.quantita)
        ) {
          this.snackbar = true;
          this.snackbar_background = "success";
          this.snackbar_icon = "mdi-check-circle";
          this.snackbar_text = "Quantità raggiunta: work order completato!";
        }
      },
    },
    visible: {
      immediate: true,
      handler() {
        if (this.visible == true) {
          var today = new Date();
          var day2 = new Date(today.getTime());
          day2.setDate(day2.getDate() + 3);
          this.date_storico_a = `${day2.getFullYear()}-${(day2.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${day2.getDate().toString().padStart(2, "0")}`;

          // Resetto le note e le altre variabili di supporto.
          this.cod_etichette_alt = new Array();
          this.id_articolo_packaging_sel = null;
          this.id_articolo_sel = null;
          this.note = "";

          // Resetto i dati all'interno della tabella dinamica.
          this.result_query = new Array();
          this.tabella_custom = new TabellaCustomClass();

          /* Devo ricevere dal BE i dati dell'avanzamento delle macchine.
           * Per riceverli devo inviare le date di start e stop dell'attività.
           * Preparo la data_da e la data_a per la request. */
          let req_data_da = null;
          if (this.work_order_sel.ora_start != null) {
            req_data_da = `${this.work_order_sel.ora_start.substring(
              6,
              10
            )}-${this.work_order_sel.ora_start.substring(
              3,
              5
            )}-${this.work_order_sel.ora_start.substring(
              0,
              2
            )} ${this.work_order_sel.ora_start.substring(11, 19)}`;
          }

          let req_data_a = null;
          if (this.work_order_sel.ora_stop != null) {
            req_data_a = `${this.work_order_sel.ora_stop.substring(
              6,
              10
            )}-${this.work_order_sel.ora_stop.substring(
              3,
              5
            )}-${this.work_order_sel.ora_stop.substring(
              0,
              2
            )} ${this.work_order_sel.ora_stop.substring(11, 19)}`;
          }

          // Prendo i codici articolo alternativi.
          this.getCodArticoli();

          // Preparo la request per l'avanzamento delle macchine.
          let getmacchinaavanzamento = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "getmacchinaavanzamentoinsit",
              token: localStorage.getItem("user_token"),
              id_utente: localStorage.getItem("id"),
              id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
              id_macchina: this.work_order_sel.id_macchina,
              data_da: req_data_da,
              data_a: req_data_a,
            },
          };

          // Consegno la request e gestisco la response.
          this.caricamento_dati = true;

          this.$store
            .dispatch("api", getmacchinaavanzamento)
            .then(async (res1) => {
              if (res1.status === 200) {
                this.caricamento_dati = false;

                // Mi prendo i parametri della query.
                await this.getTabelle();

                /* Resetto l'input dei pezzi ok da dichiarare e
                 * faccio una chiamata per ricevere gli headers
                 * e i dati della tabella dinamica, che valorizzeranno
                 * anche alcuni campi di input. */
                this.pezzi_prodotti = 0;
                this.aggiornaDatiMacchina();
              }
            })
            .catch((e) => {
              console.error(e);
              this.caricamento_dati = false;
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
            });

          // Valorizzo le note e le note_workorder con i dati del work_order_sel
          this.note_workorder =
            this.work_order_sel.note_workorder != undefined
              ? this.work_order_sel.note_workorder
              : "";
        }
      },
    },
  },
  methods: {
    async aggiornaDatiMacchina() {
      if (this.work_order_sel.flag_4_0 != 1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Macchinario non interconnesso, dati di produzione automatici non disponibili."
        );
        return;
      }

      /* Faccio scattare un overlay di caricamento.
       * I vari metodi concatenati poi lo bloccheranno. */
      this.caricamento_dati = true;

      try {
        let that = this;

        const macchina_accesa = await new Promise((resolve, reject) => {
          const request = {
            controller: "quickconnext",
            endpoint: "connext",
            response: { parse: false },
            body: {
              action: "getmachinestatus",
              token: localStorage.getItem("user_token"),
              id_macchina: that.work_order_sel.id_macchina,
            },
            method: "PUT",
            on: {
              load: function (response) {
                resolve(response);
              },
              error: function () {
                reject();
              },
            },
          };
          this.NETWORK.AjaxRequest(request);
        });

        // let getmachinestatus = {
        //   controller: "quickconnext",
        //   method: "PUT",
        //   richiesta: {
        //     action: "getmachinestatus",
        //     token: localStorage.getItem("user_token"),
        //     id_macchina: this.work_order_sel.id_macchina,
        //   },
        // };

        // const macchina_accesa = (
        //   await this.$store.dispatch("api", getmachinestatus)
        // ).data;

        if (macchina_accesa.toLowerCase() === "true") {
          await new Promise((resolve, reject) => {
            const request = {
              controller: "quickconnext",
              endpoint: "connext",
              response: { parse: false },
              body: {
                action: "requestdataupload",
                token: localStorage.getItem("user_token"),
                id_macchina: that.work_order_sel.id_macchina,
              },
              method: "PUT",
              on: {
                load: function () {
                  resolve();
                },
                error: function () {
                  reject();
                },
              },
            };
            this.NETWORK.AjaxRequest(request);
          });

          // // Se la macchina è accesa, le faccio aggiornare i dati.
          // let requestdataupload = {
          //   controller: "quickconnext",
          //   method: "PUT",
          //   richiesta: {
          //     action: "requestdataupload",
          //     token: localStorage.getItem("user_token"),
          //     id_macchina: this.work_order_sel.id_macchina,
          //   },
          // };

          // // Consegno la request e gestisco la response.
          // await this.$store.dispatch("api", requestdataupload);
        } else {
          /* Se la macchina è spenta, lo segnalo (e poi caricherò
           * nel finally gli ultimi dati disponibili). */
          this.$refs.SnackbarQV.print(
            "orange",
            "La macchina risulta attualmente spenta."
          );
        }
      } catch (e) {
        /* Se qualcosa è andato in errore lo segnalo e
         * mi stampo in console il dettaglio dell'errore. */
        console.error(e);
        this.$refs.SnackbarQV.print(
          "orange",
          "La macchina non risulta contattabile."
        );
      } finally {
        /* Carico i dati, sia che siano appena stati aggiornati
         * perché la macchina era accesa, sia che siano vecchi
         * perché la macchina era spenta. */
        this.getTabellaDinamica();
      }
    },
    aggiungiImg(messaggio) {
      /* Recupero l'immagine nel messaggio
       * che è un base64 non splittato. */
      let photo = messaggio.detail.img;

      // Uso il base64 per valorizzare la src di un oggetto immagine
      let img = new Image();

      img.onload = function () {
        /* Ora ho un'immagine di cui posso conoscere altezza e larghezza,
         * e dimensiono il div in maniera da accoglierla senza stretcharla.
         * Voglio che le dimensioni dell'immagine non siano mai
         * superiori a 100 px; se lo sono scalo le dimesioni.*/
        if (img.width > img.height && img.width > 100) {
          let width_nuova = 100;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let height_nuova = (width_nuova * img.height) / img.width;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
        } else if (img.height > img.width && img.height > 100) {
          let height_nuova = 100;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let width_nuova = (height_nuova * img.width) / img.height;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
        } else {
          document.getElementById(messaggio.detail.id).style.width =
            img.width + "px";
          document.getElementById(messaggio.detail.id).style.height =
            img.height + "px";
        }
      };

      img.src = photo;

      document.getElementById(messaggio.detail.id).style.backgroundImage =
        "url(" + img.src + ")";
    },
    calcoloFormato(valore_cella, colonna) {
      valore_cella = valore_cella[colonna.value];
      let formato = null;
      try {
        // il campo EXTRA è un json codificato in base64 (con supporto per UTF-8)
        formato = JSON.parse(decodeURIComponent(escape(atob(colonna.formato))));
      } catch (error) {
        return undefined;
      }
      let style = null;
      let valore_cella_cast;
      let tipo_dato;
      if (isFinite(Number(valore_cella)) && valore_cella != null) {
        valore_cella_cast = Number(valore_cella);
        tipo_dato = "numero";
      } else if (isFinite(Date.parse(valore_cella)) && valore_cella != null) {
        valore_cella_cast = Date.parse(valore_cella);
        tipo_dato = "data";
      } else {
        if (valore_cella == null) {
          valore_cella_cast = "";
        } else {
          valore_cella_cast = valore_cella.toString();
        }
        tipo_dato = "stringa";
      }
      const operazioni_numeriche = [
        function (item, test) {
          return item < test;
        },
        function (item, test) {
          return item <= test;
        },
        function (item, test) {
          return item == test;
        },
        function (item, test) {
          return item >= test;
        },
        function (item, test) {
          return item > test;
        },
        function (item, test) {
          return item != test;
        },
      ];
      const operazioni_stringa = [
        function () {
          return false;
        },
        function () {
          return false;
        },
        function (item, test, case_sensitive) {
          if (case_sensitive == true) {
            return item == test;
          } else {
            return item.toLowerCase() == test.toLowerCase();
          }
        },
        function () {
          return false;
        },
        function () {
          return false;
        },
        function (item, test, case_sensitive) {
          if (case_sensitive == true) {
            return item != test;
          } else {
            return item.toLowerCase() != test.toLowerCase();
          }
        },
      ];
      formato.forEach((regola) => {
        if (regola.static === true) {
          style = regola.compiled_style;
          return;
        }
        if (regola.range === true) {
          switch (tipo_dato) {
            case "numero":
              if (
                valore_cella_cast >= Number(regola.start_ref) &&
                valore_cella_cast <= Number(regola.end_ref)
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "data":
              if (
                valore_cella_cast >= Date.parse(regola.start_ref) &&
                valore_cella_cast <= Date.parse(regola.end_ref)
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
          }
        } else {
          switch (tipo_dato) {
            case "stringa":
              if (
                operazioni_stringa[Number(regola.operation)](
                  valore_cella_cast,
                  regola.start_ref
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "numero":
              if (
                operazioni_numeriche[Number(regola.operation)](
                  valore_cella_cast,
                  Number(regola.start_ref)
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "data":
              if (
                operazioni_numeriche[Number(regola.operation)](
                  valore_cella_cast,
                  Date.parse(regola.start_ref)
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
          }
        }
      });
      return style;
    },
    clickSalvaEContinua() {
      this.dialog_conferma = true;
    },
    clickControllo(id) {
      this.$emit("click_controllo", id);
    },
    clickIndietro() {
      this.$emit("click_indietro");
      this.pezzi_prodotti = null;
    },
    getCodArticoli() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolietichette",
          token: localStorage.user_token,
          id_articolo: this.work_order_sel.id_articolo,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.articoli.forEach((e) => {
              this.cod_articoli_alt.push(e);
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
    getTabellaDinamica() {
      let getstatisticadettaglio = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getstatisticadettaglio",
          token: localStorage.user_token,
          tipologia: "AD",
          id_macchina: this.work_order_sel.id_macchina,
          id_header: this.id_header_query,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", getstatisticadettaglio)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento_dati = false;
            if (res.data) {
              if (res.data.result) {
                if (res.data.result.tabelle_statistiche) {
                  if (res.data.result.tabelle_statistiche.length > 0) {
                    /* Registro la tabella che è stata definita per questo
                     * modulo (dovrebbe essere sempre soltanto una). */
                    this.tabella_custom =
                      res.data.result.tabelle_statistiche[0];

                    let performquery = {
                      controller: "Magazzino",
                      method: "POST",
                      richiesta: {
                        action: "performquery",
                        token: localStorage.user_token,
                        id_query: this.tabella_custom.id_query,
                        params: this.tabella_parametri_query,
                        query_string: "",
                      },
                    };

                    this.caricamento_dati = true;

                    this.$store
                      .dispatch("api", performquery)
                      .then((res2) => {
                        if (res2.status === 200) {
                          this.caricamento_dati = false;
                          /* Alcuni valori potrebbero essere periodici.
                           * Per evitare brutti effetti in FE nella stampa
                           * dei valori in tabella vedo quali sono i valori con
                           * una virgola e li formatto. */
                          for (const prop in res2.data.result) {
                            if (parseFloat(res2.data.result[prop]) % 1 > 0) {
                              res2.data.result[prop] = parseFloat(
                                res2.data.result[prop]
                              ).toFixed(2);
                            }
                          }

                          // Registro i dati
                          this.result_query = Array.from(res2.data.result);

                          /* Valorizzo gli input con i valori
                           * che mi arrivano dalla query. */
                          this.pezzi_prodotti =
                            res2.data.result[0].n_quantita_ok;
                        } else {
                          this.caricamento_dati = false;

                          /* Valorizzo gli input con i valori
                           * che mi arrivano dalla query. */
                          this.pezzi_prodotti = 0;

                          // Stampo una snackbar di avviso.
                          this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                          );
                        }
                      })
                      .catch((err2) => {
                        console.error(err2);
                        this.caricamento_dati = false;
                        if (err2.response.status === 400) {
                          this.$refs.SnackbarQV.print(
                            "error",
                            `${JSON.parse(err2.response.data.message).result}`
                          );
                        } else {
                          console.error(err2);
                          this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                          );
                        }
                      });
                  }
                }
              }
            } else {
              this.caricamento_dati = false;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.caricamento_dati = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getTabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "PARAMETRI_QUERY",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.tabella_parametri_query = new Array();
            res.data.forEach((p) => {
              const obj_tmp = {};
              obj_tmp.label = p.cod;
              obj_tmp.value =
                this.work_order_sel[p.des] != null
                  ? this.work_order_sel[p.des].toString()
                  : "";
              this.tabella_parametri_query.push(Object.assign({}, obj_tmp));
            });

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
    salvaEContinua() {
      this.salvaRegistrazione();
      this.pezzi_prodotti = null;
    },
    salvaRegistrazione() {
      // Controllo che si stiano registrando dei pezzi
      if (this.pezzi_prodotti === null) {
        this.snackbar = true;
        this.snackbar_background = "error";
        this.snackbar_icon = "mdi-close";
        this.snackbar_icon_color = "white";
        this.snackbar_text = "Inserire dei pezzi da registrare.";
        this.snackbar_text_color = "white";
        return;
      }

      // Controllo che i pezzi che si stanno registrando non siano meno di 0.
      if (this.pezzi_prodotti < 0) {
        this.snackbar = true;
        this.snackbar_background = "error";
        this.snackbar_icon = "mdi-close";
        this.snackbar_icon_color = "white";
        this.snackbar_text = "I pezzi registrati non possono essere meno di 0.";
        this.snackbar_text_color = "white";
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaregistrazioneinsit",
          token: localStorage.getItem("user_token"),
          id_commessa: this.work_order_sel.id_commessa,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_macchina: this.work_order_sel.id_macchina,
          flag_fase_ultima: 1,
          flag_em: this.flag_em_registrazione,
          id_articolo: this.id_articolo_sel,
          id_articolo_packaging: this.id_articolo_packaging_sel,
          note: this.note,
          quantita: this.pezzi_prodotti,
          chiudi_workorder:
            parseInt(this.pezzi_prodotti === null ? 0 : this.pezzi_prodotti) +
              parseInt(
                this.work_order_sel.pezzi_avanzati_fase === null
                  ? 0
                  : this.work_order_sel.pezzi_avanzati_fase
              ) <
            parseInt(
              this.work_order_sel.quantita === null
                ? 0
                : this.work_order_sel.quantita
            )
              ? 0
              : 1,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Emetto un evento diverso a seconda che
             * abbia solo regiatrato o che abbia finito
             * di lavorare in modo che sia intercettato dal
             * componente padre per stampare una snackbar. */
            if (
              parseInt(this.pezzi_prodotti) +
                parseInt(
                  this.work_order_sel.pezzi_avanzati_fase != null
                    ? this.work_order_sel.pezzi_avanzati_fase
                    : 0
                ) >=
              parseInt(this.work_order_sel.quantita)
            ) {
              this.$emit("work_order_completato");
            } else {
              this.$emit("click_salva");
            }
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errora nella comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        });
    },
    setCodEtichette() {
      console.log("entrato 1");
      // Resetto l'array delle etichette.
      this.cod_etichette_alt = new Array();

      /* Itero l'array dei codici articolo e quando
       * trovo quello giusto prendo le sue etichette
       * e le inserisco dentro all'array delle etichette. */
      this.cod_articoli_alt.forEach((e) => {
        if (this.id_articolo_sel == e.id_articolo) {
          e.packaging.forEach((p) => {
            this.cod_etichette_alt.push(p);
          });
        }
      });
    },
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
    document
      .getElementById("listener_registra_pezzi")
      .addEventListener("nuova_img", this.aggiungiImg);
  },
};
</script>

<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
.label {
  font-size: 20px;
}
</style>
